import { makeStyles } from "@material-ui/core";
import {
  h4Medium,
  h5Medium,
  h5Regular,
  h6Medium,
  h6Regular,
  h7Regular,
} from "../../shared/typography";
import { withOpacity } from "../../shared/mixins";

export const useContactUsStyles = makeStyles(() => ({
  modalWrapper: {
    width: "90vw",
    maxWidth: "90vw",
    padding: 24,
    background: "#FFF",
    borderRadius: 20,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    outline: "none",
    maxHeight: "95vh",
    overflowY: "auto",
    boxSizing: "border-box",

    "@media (min-width: 600px)": {
      padding: 24,
      width: "90vw", // tablets
    },
    "@media (min-width: 900px)": {
      width: "640px", // desktop
      padding: 36,
    },
  },

  successWrapper: {
    width: "80vw",
    maxWidth: 380,
    padding: 24,
    background: "#FFF",
    borderRadius: 20,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    outline: "none",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: 32,

    "@media (min-width: 600px)": {
      padding: 32,
      width: "75vw", // tablets
    },
    "@media (min-width: 900px)": {
      width: "460px", // desktop
    },
  },

  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  upperSection: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    "@media (min-width: 600px)": {
      gap: 24,
    },
    "@media (min-width: 900px)": {
      gap: 32,
    },
  },

  title: {
    ...h5Medium,
    ...withOpacity(0.8),

    "@media (min-width: 600px)": {
      ...h4Medium,
      lineHeight: "32px",
    },
  },

  closeBtn: {
    cursor: "pointer",
    fontSize: 20,
  },

  flexRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexDirection: "row",

    "@media (min-width: 600px)": {
      gap: 24,
    },
  },

  callUsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },

  callUs: {
    ...h6Medium,
    ...withOpacity(0.8),

    "@media (min-width: 600px)": {
      ...h5Medium,
    },
  },

  phoneNumber: {
    ...h6Regular,
    color: "#80BB34",
    ...withOpacity(0.8),
    direction: "ltr",
    textDecoration: "none",

    "@media (min-width: 600px)": {
      ...h5Regular,
      color: "#80BB34",
    },
  },

  orSendMessage: {
    ...h6Medium,
    ...withOpacity(0.8),
    marginBottom: 12,

    "@media (min-width: 600px)": {
      ...h5Medium,
      marginBottom: 24,
    },
  },

  contactUsForm: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  input: {
    width: "100%",
    border: "none",
    borderBottom: "1px solid rgba(21,34,47,0.08)",
    padding: "10px 0",
    outline: "none",
    textAlign: "start",
    ...h6Regular,
    ...withOpacity(0.64),
  },

  textarea: {
    width: "100%",
    border: "none",
    borderBottom: "1px solid rgba(21,34,47,0.08)",
    padding: "10px 0",
    outline: "none",
    resize: "none",
    textAlign: "start",
    ...h6Regular,
    ...withOpacity(0.64),
    height: 20,
  },

  formControl: {
    display: "flex",
    flexDirection: "column",
  },

  inputError: {
    height: 12,
    color: "red",
    fontSize: 12,
    fontFamily: "Barlow, Assistant",
    marginTop: 2,
    opacity: 0.75,
    textAlign: "start",
  },

  inputErrorWithPlaceholder: {
    borderBottom: "1px solid red !important",
    color: "red",
    "&::placeholder": {
      color: "red",
      ...withOpacity(0.7),
    },
  },

  textareaError: {
    borderBottom: "1px solid red !important",
    color: "red",
    "&::placeholder": {
      color: "red",
      ...withOpacity(0.7),
    },
  },

  submitBtn: {
    width: "100%",
    borderRadius: 16,
    background: "#80BB34",
    padding: "12px 16px 14px",
    ...h6Medium,
    color: "#FFF",
    cursor: "pointer",
    border: "none",

    "@media (min-width: 600px)": {
      ...h5Medium,
      padding: "14px 16px 18px",
      width: 320,
    },
  },

  successImg: {
    width: "70%",
    maxWidth: 200,
    margin: "0 auto 20px",

    "@media (min-width: 600px)": {
      marginBottom: 24,
    },
  },

  successModalubmitBtn: {
    width: "100%",
    borderRadius: 16,
    background: "#80BB34",
    padding: "12px 16px 14px",
    ...h6Medium,
    color: "#FFF",
    cursor: "pointer",
    border: "none",

    "@media (min-width: 600px)": {
      ...h5Medium,
      padding: "14px 16px 18px",
    },
  },
}));
